import _ from 'lodash'
import MetaMenu, { ISidebarMenuItem } from '../../all/MetaMenu'
export default _.cloneDeep(MetaMenu).filter((item: ISidebarMenuItem) => {
    return item.name !== 'Presupostos' && item.name !== 'Dades auxiliars';
}).map((item: ISidebarMenuItem) => {
    if (item.submenu && Array.isArray(item.submenu)) {
        item.submenu = item.submenu.filter((subItem: ISidebarMenuItem) => subItem.name !== 'basat');
    }
    return item;
});